const PREFIX = "uic";

/**
 *
 * @param {string} key the key to add the prefix to
 * @returns {string} the new key
 */
function addPrefix(key) {
  return `${PREFIX}-${key.toLowerCase()}`;
}

/**
 *
 * @param {string} key The key to store under
 * @param {JSON} value The value to be put in storage. This will be JSONified
 */
export function set(key, value) {
  const newKey = addPrefix(key);
  const newValue = JSON.stringify(value);
  localStorage.setItem(newKey, newValue);
}

/**
 *
 * @param {string} key the key to check
 * @param {JSON} defaultValue what to return if there's no stored value
 * @returns {JSON} The stored value
 */
export function get(key, defaultValue = null) {
  const newKey = addPrefix(key);
  const value = localStorage.getItem(newKey);

  if (value === null) {
    return defaultValue;
  }
  return JSON.parse(value);
}

/**
 *
 * @param {string} key The key to remove
 */
export function remove(key) {
  const newKey = addPrefix(key);
  localStorage.removeItem(newKey);
}

/**
 * Removes every application storage entry whose unprefixed key starts with the
 * supplied prefix.
 * @param {string} prefix Key prefix to remove
 */
export function removeByPrefix(prefix) {
  const storagePrefix = addPrefix(prefix);
  const keys = [];

  for (let index = 0; index < localStorage.length; index++) {
    const key = localStorage.key(index);
    if (key?.startsWith(storagePrefix)) keys.push(key);
  }

  for (const key of keys) {
    localStorage.removeItem(key);
  }
}
